import { createSlice } from '@reduxjs/toolkit'

const detectBrowserWeekStart = (): string => {
    try {
        const locale = new Intl.Locale(navigator.language)
        // weekInfo property (Chrome 98+) or getWeekInfo() method (newer spec)
        const firstDay = (locale as any).weekInfo?.firstDay ?? (locale as any).getWeekInfo?.()?.firstDay
        if (firstDay !== undefined) {
            return firstDay === 7 ? 'sunday' : 'monday'
        }
    } catch {
        /* ignore */
    }

    // Fallback: infer from region tag (e.g. "en-US" → "US")
    const region = navigator.language.split('-')[1]?.toUpperCase()
    const sundayFirstRegions = ['US', 'CA', 'MX', 'CN', 'JP', 'KR', 'TW', 'HK', 'MO', 'AU', 'NZ', 'ZA', 'IN', 'PH', 'SG', 'BZ', 'GT', 'HN', 'NI', 'PA', 'SV', 'DO', 'PR', 'GU']
    return region && sundayFirstRegions.includes(region) ? 'sunday' : 'monday'
}

const initialState = {
    // 'monday' or 'sunday'
    value: localStorage.getItem('weekStart') ?? detectBrowserWeekStart(),
}

export const weekStartSlice: any = createSlice({
    name: 'WEEK_START',
    initialState,
    reducers: {
        setWeekStart: (state: any, action: any) => {
            state.value = action.payload
            localStorage.setItem('weekStart', action.payload)
        },
    },
})

export const { setWeekStart } = weekStartSlice.actions

export default weekStartSlice.reducer
